import React from "react";
import { HoldingPage } from "@ecologi/react-components/src";
import { ImpactShopProductType, PlatformFeature } from "@ecologi/shared";
import {
  GetServerSidePropsContext,
  NextApiRequest,
  NextApiResponse,
} from "next";
import { ImpactShopProductPage as ImpactShopProduct } from "../../../features";
import { auth0, getImpactShopProduct } from "../../../lib";
import { withFeatureFlagGuard } from "../../../lib/auth/with-feature-flag-guard";
import { withLogging } from "../../../lib/ssr/logGetServerSideProps";

const ImpactShopProductPageComponent = ({
  product,
}: {
  product: ImpactShopProductType;
}) => <ImpactShopProduct product={product} />;

const ImpactShopProductPage = withFeatureFlagGuard(
  ImpactShopProductPageComponent,
  () => <HoldingPage />,
  {
    [PlatformFeature.Maintenance]: false,
  }
);

export const getServerSideProps = withLogging(
  async (context: GetServerSidePropsContext) => {
    const tokenCache = auth0.tokenCache(
      context.req as NextApiRequest,
      context.res as NextApiResponse
    );

    const session = await auth0.getSession(context.req);

    const product = await getImpactShopProduct(
      context.params.slug as string,
      session ? tokenCache : undefined
    );

    return {
      props: {
        layoutProps: {
          hideHeader: true,
          isWhiteBody: true,
          isProfile: true,
        },
        product,
      },
    };
  }
);

export default ImpactShopProductPage;
